import { Label } from '@britishcouncil/react-admin';
import { SessionStatus } from 'api/planning';
import { useMemo } from 'react';
import { Icon } from 'semantic-ui-react';

type Props = {
  status: SessionStatus;
  hasLinkedSession?: boolean;
};

export const SessionStatusBadge = ({ status, hasLinkedSession }: Props) => {
  const color = useMemo(() => {
    switch (status) {
      case SessionStatus.Released:
        return 'green';
      case SessionStatus.Unreleased:
        return 'grey';
    }
  }, [status]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <Label color={color} data-testid="session-status">
        {SessionStatus[status]}
      </Label>

      {hasLinkedSession && (
        <Icon
          name="linkify"
          color="blue"
        />
      )}
    </div>
  );
};